import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

export default function WhatsAppFAB({ phone }) {
  return (
    <a
      href={waLink(phone)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="relative">
        <span className="absolute inset-0 bg-palumbo-copper animate-ping opacity-30"></span>
        <div className="relative flex items-center gap-3 bg-palumbo-copper hover:bg-palumbo-copper-dark text-white font-bold uppercase tracking-wide text-xs px-5 py-4 shadow-2xl transition-colors">
          <MessageCircle size={20} strokeWidth={2} />
          <span className="hidden sm:inline">Scrivici</span>
        </div>
      </div>
    </a>
  );
}
